<p>btx-photo-input works!</p>
